export default __webpack_public_path__ + "static/media/Arrow-1.78322e3f.svg";